import { registerPlugins } from '@/utils/plugins';
import { createApp } from 'vue';
import App from '@/App.vue';
import useAppStore from '@/stores/app';

// Create vue app
const app = createApp(App);

// Register plugins
registerPlugins(app);

const appStore = useAppStore();

appStore.getInfo()
    .finally(() => {
        // Mount vue app
        app.mount('#app');
    });
